import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choice", "audio", "text"]

  showChoice() {
    this.showView("choice")
  }

  showAudio() {
    this.showView("audio")
  }

  showText() {
    this.showView("text")
  }

  showView(name) {
    for (const view of ["choice", "audio", "text"]) {
      this[`${view}Target`].classList.toggle("hidden", view !== name)
    }
  }
}
